<template>
  <div>
    <!-- 通信页面 -->
    <button @click="communicate()">通信</button>
  </div>
</template>

<script>
export default {
  methods:{
    communicate(){
      // 通信
      let userOrder = localStorage.getItem('userOrder')
      let communicateURl = `http://cs.lcyjfz.com/admin/login?userOrder=${userOrder}&query=orderDetail/84668&param=`

      window.open(communicateURl)
    }
  }
};
</script>

<style>
</style>